import script from "./SidebarTag.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarTag.vue?vue&type=script&setup=true&lang=js"

import "./SidebarTag.vue?vue&type=style&index=0&id=ccc04cc0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccc04cc0"]])

export default __exports__